module.exports = __webpack_public_path__ + "img/film1.c4088547.jpg";